import { render } from "./FCheckbox.vue?vue&type=template&id=082012b8"
import script from "./FCheckbox.vue?vue&type=script&lang=js"
export * from "./FCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__